import { createAttachmentURL, getAttachmentViewURL } from '../api/attachments-actions/attachments-info';

export function isAttachmentURL(url: string): boolean {
  return url.startsWith('attachment://');
}

export function createExtensionParams(url: string, id: string, data: any): any {
  return {
    id,
    url,
    data,
    origin: window.location.origin,
  };
}

export function createExtensionURLFromExternalURL(url: string): URL {
  const extensionURL = new URL(url);

  extensionURL.searchParams.set('extension', '1');

  return extensionURL;
}

export async function createExtensionURLFromAttachmentURL(
  attachmentsURL: string,
  token: string,
  formId: string,
  url: string,
): Promise<URL> {
  const fileName = url.replace('attachment://', '');

  const attachmentServiceURL = createAttachmentURL(
    attachmentsURL,
    fileName,
    formId,
  );

  const response = await getAttachmentViewURL(attachmentServiceURL, token);

  if (!response) {
    throw new Error(`Failed to load extension named ${fileName}.`);
  }

  return new URL(response);
}

export async function createExtensionURL(
  attachmentsURL: string,
  token: string,
  formId: string,
  url: string,
): Promise<URL> {
  if (isAttachmentURL(url)) {
    return createExtensionURLFromAttachmentURL(attachmentsURL, token, formId, url);
  }

  return createExtensionURLFromExternalURL(url);
}
